export default "__VITE_ASSET__DppSTUu$__"